import styled from "styled-components";

export const Container = styled.div `

    display: flex;
    flex-direction: column;
    width: 70dvw;
    max-width: 1800px;
    height: 95dvh;
    max-height: 95dvh;
    background: #252525;
    padding: 20px 20px 50px 20px;
    border-radius: 5px;
    overflow-y: auto;
    box-shadow: 0 0 20px 5px #00000060;
    transition: all .5s ease;

    .content {
        width: 100%;
        max-width: 800px;
        margin: 0 auto;
    }
    
    .header-watch-channel {
        display: flex;
        justify-content: space-between;
        position: sticky;
        top: -25px;
        padding: 20px 0;
        background-image: linear-gradient(to bottom, #252525,rgba(37, 37, 37, 0.66) , #25252500);
        z-index: 9;
    }

    .header-watch-channel a {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        background: #30303099;
        border: 2px solid #aaa;
        border-radius: 50%;
        padding: 10px;
        transition: all .3s ease;
    }

    .header-watch-channel a:hover {
        border-color: #fff;
        background: #000;
    }

    select {
        padding: 10px;
        border-radius: 5px;
        margin-top: 10px;
        cursor: pointer;
        border: 2px solid transparent;
        transition: all .3s ease;
    }

    select:hover {
        border: 2px solid rgb(255, 89, 0);
    }

    iframe {
        width: 100%;
        max-width: 800px;
        height: 400px;
        border: none;
        background: #000000;
        border-radius: 8px;
    }

    @media (max-width: 1000px) {
        width: 80dvw;
    }

    @media (max-width: 800px) {
        width: 85dvw;
    }

    @media (max-width: 600px) {
        width: 90dvw;
    }

`
